/* Keep Shopify Inbox intact; the header shortcut opens its existing launcher. */
(() => {
  const selector='[data-vo-support]';
  let chat,observer,wasOpen=false;
  function findControl(root,selector){
    if(!root)return null;
    const direct=root.querySelector(selector);if(direct)return direct;
    for(const el of root.querySelectorAll('*')){if(el.shadowRoot){const match=findControl(el.shadowRoot,selector);if(match)return match;}}
    return null;
  }
  const launcher=()=>findControl(chat?.shadowRoot,'button[part~="activator"]');
  function sync(){
    const next=document.querySelector('shopify-chat');
    if(next!==chat){observer?.disconnect();chat=next;if(chat){observer=new MutationObserver(sync);observer.observe(chat,{attributes:true});}}
    const open=!!chat?.hasAttribute('open'),ready=!!launcher();
    chat?.classList.toggle('vo-header-chat',ready||open);
    document.querySelectorAll(selector).forEach(link=>{
      link.setAttribute('aria-expanded',String(open));
      link.setAttribute('aria-label',open?'Close support chat':'Open support chat');
    });
    if(wasOpen&&!open){const active=document.activeElement;if(active===chat||active===document.body)document.querySelector(selector)?.focus({preventScroll:true});}
    wasOpen=open;
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest(selector);if(!link)return;
    sync();
    const control=chat?.hasAttribute('open')?findControl(chat.shadowRoot,'shopify-chat-icon-button.panel__close')||findControl(chat.shadowRoot,'button[aria-label="Close chat"]'):launcher();
    if(!control)return; // The contact-page link remains a usable fallback.
    event.preventDefault();(control.shadowRoot?.querySelector('button')||control).click();sync();
  });
  sync();
  // Inbox installs/hydrates its shadow DOM asynchronously; a lightweight check
  // also recovers if an app update replaces the custom element.
  setInterval(()=>{if(!document.hidden)sync();},1000);
  document.addEventListener('shopify:section:load',sync);
})();
